export class StoreMetaDataConstants {
    public static CORPORATE_VAT_ID = 'CORPORATE_VAT_ID';
    public static ENABLE_VAT_IN_INVOICE = 'ENABLE_VAT_IN_INVOICE';
    public static ENABLE_ORDER_STATUS_UPDATE = 'ENABLE_ORDER_STATUS_UPDATE';
    public static ORGANIZATION_NUMBER="ORGANIZATION_NUMBER";
    public static PLACE_OF_INCORPORATION='PLACE_OF_INCORPORATION';
    public static TAX_CERTIFICATE_NOTE ='TAX_CERTIFICATE_NOTE';
    public static ENABLE_WATERMARK_IN_INVOICE = 'ENABLE_WATERMARK_IN_INVOICE';
    public static ENABLE_SERVICE_ORDER = 'ENABLE_SERVICE_ORDER';
    public static CREDITOR_ID = 'CREDITOR_ID';
}


// WEBPACK FOOTER //
// ./src/app/customerservice/constants/store-metadata.constants.ts